import React, { useState, useEffect } from "react";
import { AxiosAPI, getGroupID } from "../../../../../../helpers/AxiosAPI";
import { Nav, NavItem, NavLink, TabContent, TabPane, Button } from "reactstrap";
import classnames from "classnames";
import { gAPI_Twilio_Templates } from "../../../../../../constants/APIs";
import AddNewTemplate from "./AddNewTemplate";
import TemplateListItem from "./TemplateListItem";
import { Bolt } from "@mui/icons-material";
const CHANNELS = [
    { key: "whatsapp", label: "WhatsApp" },
    { key: "sms", label: "SMS" },
];
const TemplateTableHeader = () => (
    <div
        className="d-flex align-items-center px-3 py-2"
        style={{
            fontSize: 13,
            color: "#8A8A8A",
            borderBottom: "1px solid #F0F0F0",
            fontWeight: 500,
        }}
    >
        <div style={{ flex: 2, fontWeight: 'Bold' }}>Template Name</div>
        <div style={{ flex: 4, fontWeight: 'Bold' }}>Template Body</div>
        <div style={{ flex: 2, fontWeight: 'Bold' }}>Template ID</div>
        <div style={{ width: 90, fontWeight: 'Bold' }}>Type</div>
        <div style={{ width: 90, textAlign: "right", fontWeight: 'Bold' }}>Action</div>
    </div>
);
const TemplateForm = ({ propertyId, groupId, userName }) => {
    const initialFormState = {
        name: "",
        channels: [],
        message: "",
        placeholderMap: {},
    };

    const [editId, setEditId] = useState(null);
    const [activeChannel, setActiveChannel] = useState("whatsapp");
    const [showAddModal, setShowAddModal] = useState(false);
    const [templateList, setTemplateList] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const toggleChannel = (channel) => {
        if (activeChannel !== channel) {
            setActiveChannel(channel);
        }
    };
    useEffect(() => {
        if (!propertyId) return;
        AxiosAPI({
            method: "get",
            url: `${gAPI_Twilio_Templates}?group_id=${groupId}&property_id=${propertyId}`,
        }).then((res) => {
            setTemplateList(res.data || []);
        });
    }, [propertyId, showAddModal]);
    const toggleAddModal = () => {
        setShowAddModal(!showAddModal);
    };
    const openCreateModal = () => {
        setSelectedTemplate(null);
        setShowAddModal(true);
    };
    const filteredTemplates = templateList.filter(t =>
        t.channel?.some(
            ch => ch.toLowerCase() === activeChannel
        )
    );
    const handleEditTemplate = async (template) => {
        try {
            setEditId(template.id);
            console.log('idsss', template)
            const res = await AxiosAPI({
                method: "get",
                url: `${gAPI_Twilio_Templates}/${template.id}`,
                params: {
                    group_id: groupId,
                },
            });

            setSelectedTemplate({
                ...res.data,
                id: template.id,
            });
            setShowAddModal(true);
        } catch (error) {
            console.error("Failed to fetch template details", error);
        }
    };

    const getTemplatesByChannel = (channelKey) => {
        return templateList.filter(t =>
            t.channel?.some(
                ch => ch.toLowerCase() === channelKey.toLowerCase()
            )
        );
    };
    return (
        <div className="p-3">
            <div
                className="d-flex justify-content-start align-items-center mb-3"
                style={{ borderBottom: "1px solid #eee", paddingBottom: 10, gap: 12 }}
            >
                <h5
                    style={{
                        margin: 0,
                        color: "var(--theme-color-1)",
                        fontWeight: 600,
                    }}
                >
                    Templates
                </h5>

                <Button
                    color="primary"
                    size="xs"
                    outline
                    className="top-right-button mr-1 "
                    onClick={openCreateModal}
                >
                    + Add New
                </Button>
            </div>

            {/* Channel Tabs */}
            <Nav tabs className="separator-tabs mb-3">
                {CHANNELS.map(({ key, label }) => (
                    <NavItem key={key}>
                        <NavLink
                            className={classnames({
                                active: activeChannel === key,
                            })}
                            onClick={() => toggleChannel(key)}
                            style={{ cursor: "pointer" }}
                        >
                            {label}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>

            {/* Channel Content */}
            <TabContent activeTab={activeChannel}>
                {/* <TabPane tabId="chat">
                    <h5>Chat Template</h5>
                    <div>Template In progress</div>
                </TabPane>

                <TabPane tabId="email">
                    <h5>Email Template</h5>
                    <div>Template In progress</div>
                </TabPane> */}

                <TabPane tabId="whatsapp">
                    {getTemplatesByChannel("whatsapp").length === 0 ? (
                        <div className="text-muted px-3">No WhatsApp templates found</div>
                    ) : (
                        <>
                            <TemplateTableHeader />

                            {getTemplatesByChannel("whatsapp").map(template => (
                                <TemplateListItem
                                    key={template.templateId}
                                    template={template}
                                    onEdit={handleEditTemplate}
                                />
                            ))}
                        </>
                    )}
                </TabPane>

                <TabPane tabId="sms">
                    {getTemplatesByChannel("sms").length === 0 ? (
                        <div className="text-muted px-3">No SMS templates found</div>
                    ) : (
                        <>
                            <TemplateTableHeader />

                            {getTemplatesByChannel("sms").map(template => (
                                <TemplateListItem
                                    key={template.templateId}
                                    template={template}
                                    onEdit={handleEditTemplate}
                                />
                            ))}
                        </>
                    )}
                </TabPane>
            </TabContent>
            <AddNewTemplate
                visible={showAddModal}
                toggleModal={toggleAddModal}
                formLabel={selectedTemplate ? "Update Template" : "Create New Template"}
                propertyId={propertyId}
                groupId={groupId}
                userName={userName}
                defaultChannel={activeChannel}
                templateData={selectedTemplate}
            />
        </div >
    );
};

export default TemplateForm;